import React, { useEffect, useState, useCallback } from 'react';
import { buildApiUrl } from '../config/api';

/**
 * 公司端：变更报告工程师台 + 历史归档台账（精简页）
 */
export default function YingshanPortal() {
  const [tab, setTab] = useState('reports');
  const [sites, setSites] = useState([{ site_id: 'yingshan', name: '营山污水厂' }]);
  const [siteId, setSiteId] = useState('yingshan');
  const [reports, setReports] = useState([]);
  const [archives, setArchives] = useState([]);
  const [accounts, setAccounts] = useState({ accounts: [], capabilities: [] });
  const [msg, setMsg] = useState('');

  useEffect(() => {
    (async () => {
      try {
        const res = await fetch(buildApiUrl('/hmi/sites'));
        const j = await res.json();
        const items = (j.data && (j.data.items || j.data)) || [];
        if (Array.isArray(items) && items.length) {
          setSites(items);
          if (!items.some((s) => s.site_id === siteId)) {
            setSiteId(items[0].site_id || 'yingshan');
          }
        }
      } catch (_) {
        /* keep default */
      }
    })();
  }, []);

  const load = useCallback(async () => {
    try {
      if (tab === 'reports') {
        const r = await fetch(buildApiUrl(`/hmi/change-reports?site_id=${encodeURIComponent(siteId)}`));
        const j = await r.json();
        setReports((j.data && (j.data.items || j.data)) || []);
      } else if (tab === 'archives') {
        const r = await fetch(buildApiUrl('/hmi/archives'));
        const j = await r.json();
        setArchives((j.data && (j.data.items || j.data)) || []);
      } else if (tab === 'accounts') {
        const r = await fetch(buildApiUrl(`/hmi/accounts/sync/${encodeURIComponent(siteId)}`));
        const j = await r.json();
        setAccounts(j.data || { accounts: [], capabilities: [] });
      }
      setMsg('');
    } catch (e) {
      setMsg(e.message || '加载失败');
    }
  }, [tab, siteId]);

  useEffect(() => {
    load();
  }, [load]);

  const confirmReport = async (id) => {
    const r = await fetch(buildApiUrl(`/hmi/change-reports/${id}/engineer-confirm`), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ engineer_id: 'web-engineer', report_id: id }),
    });
    const j = await r.json();
    setMsg(j.success ? `已确认 ${id}` : j.message || '失败');
    load();
  };

  const seedAccounts = async () => {
    const body = {
      site_id: siteId,
      accounts: [
        { username: 'worker01', display_name: '现场工人', role: 'worker', enabled: true },
        { username: 'admin01', display_name: '现场管理员', role: 'site_admin', enabled: true },
      ],
      capabilities: {
        worker01: { canUseAiChat: true, canRunPhysicalGuide: true, canViewChangeReports: false },
        admin01: {
          canUseAiChat: true,
          canRunPhysicalGuide: true,
          canSiteApproveWrite: true,
          canSiteEmergencyWrite: true,
          canViewChangeReports: true,
        },
      },
    };
    const r = await fetch(buildApiUrl('/hmi/accounts/sync'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    });
    const j = await r.json();
    setMsg(j.success ? '账号权能已下发快照' : j.message || '失败');
    load();
  };

  return (
    <div style={{ padding: 24, fontFamily: 'system-ui, sans-serif', maxWidth: 1100, margin: '0 auto' }}>
      <h1>营山公司端门户</h1>
      <p style={{ color: '#666' }}>
        工程师台 / 历史归档 / 账号权能下发　
        <label>
          站点{' '}
          <select value={siteId} onChange={(e) => setSiteId(e.target.value)}>
            {sites.map((s) => (
              <option key={s.site_id} value={s.site_id}>
                {s.name || s.site_id}
              </option>
            ))}
          </select>
        </label>
      </p>
      <div style={{ display: 'flex', gap: 8, marginBottom: 16 }}>
        {[
          ['reports', '变更报告'],
          ['archives', '历史归档'],
          ['accounts', '账号权能'],
        ].map(([k, label]) => (
          <button key={k} type="button" onClick={() => setTab(k)} style={{ fontWeight: tab === k ? 700 : 400 }}>
            {label}
          </button>
        ))}
        <a href="/yingshan-board" style={{ marginLeft: 'auto' }}>
          实时看板
        </a>
      </div>
      {msg && <p style={{ color: '#b45309' }}>{msg}</p>}

      {tab === 'reports' && (
        <table width="100%" cellPadding="8" style={{ borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ textAlign: 'left', borderBottom: '1px solid #ddd' }}>
              <th>ID</th>
              <th>状态</th>
              <th>摘要</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            {(Array.isArray(reports) ? reports : []).map((r) => (
              <tr key={r.id || r.report_id} style={{ borderBottom: '1px solid #eee' }}>
                <td>{r.id || r.report_id}</td>
                <td>{r.status}</td>
                <td>{r.title || r.summary || r.where_error || '—'}</td>
                <td>
                  <button type="button" onClick={() => confirmReport(r.id || r.report_id)}>
                    工程师确认
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {tab === 'archives' && (
        <table width="100%" cellPadding="8" style={{ borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ textAlign: 'left', borderBottom: '1px solid #ddd' }}>
              <th>站点</th>
              <th>年月</th>
              <th>大小</th>
              <th>哈希</th>
              <th>下载</th>
            </tr>
          </thead>
          <tbody>
            {(Array.isArray(archives) ? archives : []).map((a) => (
              <tr key={a.id || `${a.site_id}-${a.year_month || a.period}`} style={{ borderBottom: '1px solid #eee' }}>
                <td>{a.site_id}</td>
                <td>{a.year_month || a.period || a.month}</td>
                <td>{a.size || a.size_bytes || a.bytes || '—'}</td>
                <td style={{ fontSize: 12 }}>{(a.sha256 || a.hash || '').slice(0, 16)}…</td>
                <td>
                  <a href={buildApiUrl(`/hmi/archives/${a.id}/download`)}>下载</a>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {tab === 'accounts' && (
        <div>
          <button type="button" onClick={seedAccounts}>
            下发示例账号权能快照
          </button>
          <pre style={{ background: '#f6f6f6', padding: 12, overflow: 'auto' }}>
            {JSON.stringify(accounts, null, 2)}
          </pre>
        </div>
      )}
    </div>
  );
}
